function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Item = ({
  children,
  isActive,
  isSelected,
  ...props
}) => {
  const classes = classNames({
    autocomplete__item: true,
    'autocomplete__item--active': isActive,
    'autocomplete__item--selected': isSelected
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classes
  }), children);
};

Item.propTypes = {
  children: PropTypes.any,
  isActive: PropTypes.bool,
  isSelected: PropTypes.bool,
  disabled: PropTypes.bool
};
export default Item;